import { openDB, DBSchema } from "idb";

const DB_NAME = "casa";
const DB_VERSION = 1;
const STORE_NAME = "config";

export interface CasaDB extends DBSchema {
    [STORE_NAME]: {
        key: string;
        value: Record<string, any>;
    }
}


export const getDB = async () => {
  return openDB<CasaDB>(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

export const saveConfig = async (
  key: string,
  config: Record<string, any>
) => {
  const db = await getDB();
  await db.put(STORE_NAME, config, key);
};

export const getConfig = async (
  key: string
) => {
  const db = await getDB();
  return db.get(STORE_NAME, key) as Promise<Record<string, any> | undefined>;
};
